module.exports = __webpack_public_path__ + "assets/media/evening.fbbaf535.mp3";